import { render, staticRenderFns } from "./TrophyTable.vue?vue&type=template&id=d695abd2&"
import script from "./TrophyTable.vue?vue&type=script&lang=js&"
export * from "./TrophyTable.vue?vue&type=script&lang=js&"
import style0 from "./TrophyTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrophyTable.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
installComponents(component, {
  VBadge,
  VDataTable,
})
